module.exports = __webpack_public_path__ + "static/media/icon.088a2552.svg";